var forms = document.querySelectorAll('.js-fixably-form');
var fixablyStatuses = window.fixably.statuses;
var fixablyErrors = window.fixably.errors;
var fixablyArticles = window.fixably.articles;
var fixablyStatus = window.fixably.status;
var truck = window.fixably.images.truck;
var box = window.fixably.images.box;
var text = window.fixably.images.text;

forms.forEach((form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    var submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('button--loading');

    var elements = form.elements;
    var emailValue = elements.email.value;
    var orderNumberValue = elements.order_number.value;

    var resultEl = form.querySelector('.result');
    resultEl.style.display = 'none';

    var showResult = (data) => {
      var type = data.repair_status;
      var resultObject = fixablyStatuses.find((item) => item.type === type);

      if (resultObject) {
        resultEl.style.display = 'block';
        resultEl.classList.remove('error');

        var notesHtml = data.notes
          .map((note) => {
            var text = note.text;
            var createdAt = note.createdAt;

            if (text === '/') {
              return '';
            }

            return `
              <div class="fixably-form__note">
                <div class="fixably-form__note-date">${createdAt}</div>
                <div class="fixably-form__note-text">${text}</div>
              </div>
            `;
          })
          .join('');

        var articlesList = data.articles.map((article) => {
          if (article && article.code && article.name) {
            return `<li>${article.code} - ${article.name}</li>`;
          }
          return '';
        }).join('');

        var result = `
          <div class="fixably-form__flex">
            <div class="fixably-form__icon">
              <img src="${truck}" alt="">
            </div>
            <div>
              <strong>${fixablyStatus}: ${resultObject.title}</strong><br>
              ${resultObject.info}
            </div>
          </div>
          <div class="fixably-form__flex">
            <div class="fixably-form__icon">
              <img src="${box}" alt="">
            </div>
            <div>
              <strong>${fixablyArticles}:</strong><br>
              <ul class="fixably-form__ul">
                ${articlesList}
              </ul>
            </div>
          </div>
          <div class="fixably-form__flex">
            <div class="fixably-form__icon">
              <img src="${text}" alt="">
            </div>
            <div>
              ${notesHtml}
            </div>
          </div>`;

        resultEl.innerHTML = result;
      }
    };

    var showError = (error) => {
      resultEl.style.display = 'block';
      resultEl.classList.add('error');

      var errorTerm = error
        .toString()
        .replace('TypeError: ', '')
        .toLowerCase()
        .replaceAll(' ', '_');
      var errorText = fixablyErrors[errorTerm] ? fixablyErrors[errorTerm] : '';

      if (errorText === '') {
        errorText = fixablyErrors['error_fixably_no_info_found_for_the_provided_data'];
      }

      resultEl.innerHTML = errorText;
      resultEl.classList.add('error');
    };

    if (emailValue !== '' && orderNumberValue !== '') {
      var url = `/apps/lab9/proxy/repair-status?email=${emailValue}&order_number=${orderNumberValue}`;

      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          submitButton.classList.remove('button--loading');
          var error = data.error;
          console.log(error);
          if (error && error !== '') {
            showError(error);
          } else {
            showResult(data);
          }
        })
        .catch((error) => {
          console.log(error);
          showError(error);
        });
    }
  });
});
